const loadBundles = () => {


  /* Custom carousel */
  const carousels = [...document.querySelectorAll('[data-behaviour="carousel"]')]

  if (carousels.length) {
    carousels.forEach((carousel) => {
      import('../components/carousel.js').then((component) =>
        component.render(carousel)
      )
    })
  }

}

export default loadBundles
